import React from "react";
import { useNavigate } from "react-router-dom";
import "./RatedManagerCard.css";
import defaultLogo from "../../assets/images/logo.png";

const RatedManagerCard = ({ manager }) => {
  const navigate = useNavigate();

  const handleManagerClick = () => {
    navigate(
      `/manager?name=${encodeURIComponent(
        manager.manager_full_name
      )}&id=${manager.manager_id}`
    );
  };

  const handleCompanyClick = () => {
    navigate(
      `/company-profile?name=${encodeURIComponent(manager.company_name)}&id=${
        manager.company_id
      }`
    );
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} className={`star ${i <= rating ? "filled" : "empty"}`}>
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="rated-manager-card">
      <div className="card-header">
        <div className="company-info" onClick={handleCompanyClick}>
          <img
            src={manager.company_logo_url}
            alt={manager.company_name}
            className="company-logo"
            onError={(e) => {
              e.target.src = defaultLogo;
            }}
          />
          <span className="company-name">{manager.company_name}</span>
        </div>
        <div className="date-info">
          <i className="bi bi-clock"></i>
          <span>{manager.creation_time}</span>
        </div>
      </div>

      <div className="manager-info" onClick={handleManagerClick}>
        <h4 className="manager-name">{manager.manager_full_name}</h4>
        <p className="manager-position">{manager.manager_position}</p>
        <p className="manager-location">{manager.location}</p>
      </div>

      <div className="rating-section">
        <div className="stars">{renderStars(manager.review_rating)}</div>
        <div className="review-text">
          <textarea
            value={manager.review}
            readOnly
            placeholder="This manager is so and so..."
            className="review-textarea"
          />
        </div>
      </div>
    </div>
  );
};

export default RatedManagerCard;
